import { createNode, ZonedDateTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromZonedDateTime } from '../../utils/temporal';

export const ParseZonedDateTime = createNode({
    id: 'Parse ZonedDateTime',
    name: 'Parse ZonedDateTime',
    description: 'Parses a ZonedDateTime from an RFC 9557 string (e.g. "2024-03-15T14:30:00-05:00[America/New_York]")',
    aiDescription:
        'Takes an RFC 9557 string (e.g. "2024-03-15T14:30:00-05:00[America/New_York]") on the "Text" port and outputs a parsed ZonedDateTime on the "ZonedDateTime" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Text: { kind: 'string' },
    },
    outPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    execute: function (input) {
        const zdt = Temporal.ZonedDateTime.from(input.inPorts.Text);
        return { output: { ZonedDateTime: fromZonedDateTime(zdt) } };
    },
});
